import { AllowedRuleSet, PartnerGroupRules, UserGroupRules } from 'src/graphql';

/**
 * Best-effort Billing nav/route gate: AccessToBilling plus Connect *or*
 * invoices. Partner + user `access_to_view_partner_invoices` share one id, so
 * `checkValidity` cannot AND them — the invoices *section* still requires both
 * via separate partner/user reads in `stripe-settings.view.tsx`, which may
 * redirect to Company if the merged rule was optimistic.
 */
export const BILLING_PAGE_ALLOWED_RULES: AllowedRuleSet[] = [
  {
    rules: [UserGroupRules.AccessToBilling, PartnerGroupRules.AccessToSubscriptionManagement],
  },
  {
    rules: [UserGroupRules.AccessToBilling, PartnerGroupRules.AccessToViewPartnerInvoices],
  },
];
